import React from "react";
import { Input } from "@revvsales/components";
import { RevvForm } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

export default class RadioFieldFormMode extends React.Component {
  state = {
    radioFieldValues: JSON.parse(JSON.stringify(this.props.initialProps.value)),
  };

  _updateRadioInfo = (id, opt) => {
    this.props._updateField(id, opt);
    this.props._updateDynamicFieldsInDoc(id, opt);
    this.props.filledStatus(true);
  };

  render() {
    const { id, meta, /* docIsLocked */ value } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.radioFieldValues}
          customFieldName="RADIO"
          customFieldComponentRules={CustomFieldComponentRules}
          validateOnChange
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={() => (
            <React.Fragment>
              {meta.options.map(opt => (
                <span className="checkboxleftmar">
                  <Input
                    type="radio"
                    data-test="input-revv-inp-checkbox-or-radio"
                    checked={opt === value}
                    onChange={() => this._updateRadioInfo(id, opt)}
                    disabled={this.props.isLocked}
                  />
                  <span className="dynamicfield-checkboxinputlabel dynamicfield-inputlabel-checkbox">
                    {opt}
                  </span>
                </span>
              ))}
            </React.Fragment>
          )}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/RadioFormMode.js